import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';

import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const AddEditParts = ({
  closeModal,
  saveParts,
  callback,
  currentItem,
  isEdit,
  Styled,
}) => {
  const { i18n } = useTranslation();
  const apiId = 'saveParts';

  const initialValues = {
    id: currentItem?.id || '',
    partName: currentItem?.partName || '',
    partsInInventory: currentItem?.partsInInventory || '',
    cost: currentItem?.cost || '',
  };

  const validationSchema = Yup.object().shape({
    partName: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
    partsInInventory: Yup.string().required(
      i18n.t('common.fieldRequiredMessage')
    ),
    cost: Yup.string()
      .matches(/^\d*(\.\d+)?$/, i18n.t('parts.costError'))
      .required(i18n.t('common.fieldRequiredMessage')),
  });

  const handleSubmit = (fields) => {
    const finalData = {
      ...fields,
      partsInInventory: fields?.partsInInventory
        ? +fields.partsInInventory
        : '',
    };

    saveParts({
      apiId,
      data: finalData,
      callback,
      i18n,
    });

    closeModal();
  };

  return (
    <Styled.Wrapper>
      <Form
        type="server"
        direction="column"
        initialValues={initialValues}
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        customProps={{ isEdit }}
        handleClear={() => { }}
        validationSchema={validationSchema}
      />
    </Styled.Wrapper>
  );
};

AddEditParts.propTypes = {
  closeModal: PropTypes.func.isRequired,
  saveParts: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  currentItem: PropTypes.object,
  isEdit: PropTypes.bool,
  Styled: PropTypes.object.isRequired,
};

export default AddEditParts;